const handleInsuranceFromEstimationPrice = (value: any, isNonCod: boolean) => {
  let result = "";
  const convertValue = Number(value.replace(/\./g, ""));
  if (convertValue >= 5000000 && isNonCod) {
    result = "basic_and_disable_select_insurance";
  } 
  return result;
};
export default handleInsuranceFromEstimationPrice;
